// @flow
import * as React from 'react';
import styled from 'styled-components';
import { below } from '../../assets/css/media';
import colors from '../../assets/css/colors';
import Caution from '../../components/Icons/Caution';

import {
	ModalContainer,
	ButtonSecondary,
	ButtonAlert
} from '../../components';

const ButtonWrapper = styled.div`
	display: flex;
	justify-content: center;
	margin: 0 1em;
	padding: 0 0 40px;

	button {
		text-transform: uppercase;
		min-width: 200px;
		margin: 0 10px;
		${below.desktop`
			min-width: 85px;
		`}
	}
`;

const Copy = styled.p`
	font-size: 14px;
	line-height: 1.7;
	width: 100%;
	padding: 0 30px;
	color: ${colors.title};
	box-sizing: border-box;
	text-align: center;
	margin: 30px 0;
`;

const CautionIcon = styled(Caution)`
	color: ${colors.red};
	height: 100px;
	width: 100px;
	display: block;
	position: relative;
	margin: 30px auto 20px;
	${below.tablet`
		width: 60px;
		height: 60px;
		margin: 20px auto 15px;
	`}
`;


type Props = {
	closeClick: Function,
	confirmClick: Function,
	cancelClick: Function,
	header_text: string,
	body_text?: string,
};

export const ConfirmationModal = ({
	closeClick,
	confirmClick,
	cancelClick,
	header_text,
	body_text,
}: Props) => (
	<ModalContainer header_text={header_text} onClick={closeClick}>
		<CautionIcon />
		<Copy>
			{body_text}
		</Copy>
		<ButtonWrapper>
			<ButtonSecondary onClick={cancelClick}>
				Cancel
			</ButtonSecondary>
			<ButtonAlert onClick={confirmClick}>
				Confirm
			</ButtonAlert>
		</ButtonWrapper>
	</ModalContainer>
);

export default ConfirmationModal;


// WEBPACK FOOTER //
// ./src/components/Modal/ConfirmationModal.js